<template>
  <div class="chat-bubble-container">
    <div v-if="message.type === 'user'" :class="['chat-content', 'chat-content-user']">
      <div class="chat-bubble-user">
        {{ compProps.message.text }}
      </div>
    </div>
    <div v-else :class="['chat-content', 'chat-content-assistant']">
      <div v-if="compProps.message.type === 'assistant'" class="chat-bubble-assistant">
        <VueShowdown :markdown="compProps.message.text" />
      </div>
      <div v-else class="chat-bubble-assistant justify-space-around align-center" style="width: 75px; height: 40px">
        <span class="dot"></span>
        <span class="dot"></span>
        <span class="dot"></span>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { VueShowdown } from "vue-showdown";
import { Message } from "./Message";

const compProps = defineProps<{
  message: Message;
}>();
</script>

<style scoped>
.chat-bubble-container {
  width: 100%;
  word-break: break-word;
  white-space: pre-wrap;
}

.chat-content {
  display: flex;
  align-items: flex-start;
  margin-left: 15px;
}

.chat-content-user {
  justify-content: flex-end;
  margin-right: 15px;
}

.chat-bubble-user,
.chat-bubble-assistant {
  padding: 10px 25px;
  display: flex;
  min-width: 30px;
  min-height: 35px;
  max-width: 90%;
  margin: 10px 10px 3px;
  box-sizing: border-box;
  position: relative;
  border-radius: 10px;
}

.chat-bubble-user::before,
.chat-bubble-assistant::before {
  content: "\00a0";
  display: block;
  height: 16px;
  position: absolute;
  top: 11px;
  transform: rotate(29deg) skew(-35deg);
  -moz-transform: rotate(29deg) skew(-35deg);
  -ms-transform: rotate(29deg) skew(-35deg);
  -o-transform: rotate(29deg) skew(-35deg);
  -webkit-transform: rotate(29deg) skew(-35deg);
  width: 20px;
}

.chat-bubble-assistant::before {
  left: -9px;
  background-color: rgba(var(--v-theme-toolbar));
}

.chat-bubble-user::before {
  right: -9px;
  background-color: rgba(var(--v-theme-contrast-grey-medium));
}

.chat-content-assistant .chat-bubble-assistant {
  background-color: rgba(var(--v-theme-toolbar));
}

.chat-content-user .chat-bubble-user {
  background-color: rgba(var(--v-theme-contrast-grey-medium));
}

.dot {
  height: 5px;
  width: 5px;
  border-radius: 100%;
  display: inline-block;
  background-color: rgba(var(--v-theme-font));
  animation: 1.2s typing-dot ease-in-out infinite;
}

.dot:nth-of-type(2) {
  animation-delay: 0.15s;
}

.dot:nth-of-type(3) {
  animation-delay: 0.25s;
}

@keyframes typing-dot {
  15% {
    transform: translateY(-35%);
    opacity: 0.5;
  }
  30% {
    transform: translateY(0%);
    opacity: 1;
  }
}
</style>
